module.exports = __webpack_public_path__ + "img/252.24dcd281.jpg";